import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'employee_guid': 'String!',
	'code': 'String!',
	'active': 'String',
}

export default gql(`
	mutation employee_push_notification_token( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_push_notification_token( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        code
	        active
	    }
	}
`);

